import React from "react"


export const StarSvg = () => {
    return (
        <svg width="11" height="11" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.8 0.664062L6.28317 3.72294L9.6 4.21638L7.20014 6.59591L7.76661 9.95758L4.80027 8.36956L1.83366 9.95758L2.40014 6.59591L0 4.21638L3.31683 3.72294L4.8 0.664062Z" fill="#F2CC00" />
        </svg>
    )
}